import { openDiscordProps } from "@core-components/button/ButtonVariants";
import SSContainer from "@core-components/container/Container";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Flex, Group, Text } from "@mantine/core";

const NewsBanner: React.FC = () => {
  const { t } = useAppTranslation("components.layout.newsBanner");

  return (
    <Flex
      className="gradient-blue-purple z-10 w-full px-6 py-3"
      justify="center"
    >
      <SSContainer className="w-full">
        <Group className="w-full justify-center gap-2 font-bold md:justify-between">
          <Text
            className="font-inter font-medium text-primary-white"
            fw={"normal"}
            fz={"lg"}
            ta={"center"}
          >
            {t("discountCode")}
          </Text>
          <Button
            {...openDiscordProps}
            className="w-full font-extrabold font-inter text-primary-white uppercase md:w-auto"
            variant="transparent"
          >
            {t("joinDiscord")}
          </Button>
        </Group>
      </SSContainer>
    </Flex>
  );
};

export default NewsBanner;
